// @flow

const options = {
  release: process.env.COMMIT_HASH,
  environment: process.env.API_ENV,
  ignoreErrors: [
    // Random plugins/extensions
    "top.GLOBALS",
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
    "originalCreateNotification",
    "canvas.contentDocument",
    "MyApp_RemoveAllHighlights",
    "http://tt.epicplay.com",
    "Can't find variable: ZiteReader",
    "jigsaw is not defined",
    "ComboSearch is not defined",
    "http://loading.retry.widdit.com/",
    "atomicFindClose",
    // Facebook borked
    "fb_xd_fragment",
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    "bmi_SafeAddOnload",
    "EBCallBackMessageReceived",
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    "conduitPage"
  ],
  ignoreUrls: [
    // Facebook flakiness
    (/graph\.facebook\.com/i: RegExp),
    // Facebook blocked
    (/connect\.facebook\.net\/en_US\/all\.js/i: RegExp),
    // Woopra flakiness
    (/eatdifferent\.com\.woopra-ns\.com/i: RegExp),
    (/static\.woopra\.com\/js\/woopra\.js/i: RegExp),
    // Chrome extensions
    (/extensions\//i: RegExp),
    (/^chrome:\/\//i: RegExp),
    // Other plugins
    (/127\.0\.0\.1:4001\/isrunning/i: RegExp), // Cacaoweb
    (/webappstoolbarba\.texthelp\.com\//i: RegExp),
    (/metrics\.itunes\.apple\.com\.edgesuite\.net\//i: RegExp)
  ]
}
const dsn = "https://35765a020ec340e9954e640b4fe5afd2@sentry.io/231414"

export { options, dsn }
